import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=ac4be604&scoped=true&"
import script from "./brand.vue?vue&type=script&lang=js&"
export * from "./brand.vue?vue&type=script&lang=js&"
import style0 from "./brand.vue?vue&type=style&index=0&id=ac4be604&prod&lang=less&scoped=true&"
import style1 from "./brand.vue?vue&type=style&index=1&id=ac4be604&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4be604",
  null
  
)

export default component.exports